import gql from 'graphql-tag';

export default gql`
  mutation sendOptInMessage($userId: UUID!) {
    sendOptInMessage(userId: $userId)
  }
`;
